import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import kakaoImg from '../../../../../asset/img/linktodata_m_kakao_img.jpg';

import Button from '../../../../../components/common/Button';

// import SubTitleSection from '../../../components/SubTitleSection';
import Typography from '../../../../../components/common/Typography';
import { getAlertMessageFunction } from '../../../../../common/Util';

import { kakaoTossSelectItem02 } from '../../../../../common/data';
import AlertContext from '../../../../../context/AlertContext';
import { certifyDateUpdate, kakaoCertStatus, tossCertStatus } from '../../../resultQuerySlice';
import { getCertifyFlag } from '../../../../common/commonSlice';
import { kakaoCertErrorHandler } from '../../../util';
// import Button from '../../../components/common/Button';

const Step3 = ({ kakaoData, selectedItem, onCloseHandler, modalCloseHandler }) => {
  const dispatch = useDispatch();
  const {
    alertActions: { alertMessage },
  } = useContext(AlertContext);

  const { t } = useTranslation('eDocuments');
  const { t: tCommon } = useTranslation('common');
  const { myInfo } = useSelector(state => state.myInfo);
  const { tossToken } = useSelector(state => state.resultQuery);

  const itemList = kakaoTossSelectItem02(t);
  const [item, setItem] = useState({
    title: '카카오톡',
    img: kakaoImg,
    description: (
      <>
        1. 카카오 인증서 이용에 문제가 있는 경우, [고객센터 도움말] 에서 해결 방법을 찾아보세요.
        <br />
        2. 문제가 지속되면 [고객센터 문의하기] 또는 [상담톡 채널] 채팅하기를 통해 문의해 주세요.
      </>
    ),
  });
  // const { t } = useTranslation('eDocuments');
  useEffect(() => {
    setItem(itemList[selectedItem]);
  }, [selectedItem]);

  const certCheck = async () => {
    // 카카오
    let params = {
      tx_id: kakaoData,
    };
    let api = selectedItem == 0 ? kakaoCertStatus : tossCertStatus;

    //토스
    if (selectedItem == 1) {
      params = {
        txId: kakaoData.txId,
        access_token: tossToken,
      };
    }

    try {
      const response = await dispatch(api(params)).unwrap();

      const { resultCode, status, resultData } = response;
      //toss는 status가 resultData 안에 있음.
      let errorStatus = selectedItem == 0 ? status : resultData.status;
      //인증실패
      if (resultCode != '1' && errorStatus != 'COMPLETED') {
        //토큰 만료(토스)
        if (resultCode == '-2') {
          alertMessage(tCommon('alertMessage.alertMessage18'));
          modalCloseHandler();
          return;
        }
        //유효시간 만료 or 인증 완료안하고 누를 때
        else if (errorStatus) alertMessage(tCommon(kakaoCertErrorHandler(errorStatus)));
        //인증에 실패하였습니다.
        else alertMessage(tCommon('alertMessage.alertMessage17'));
        return;
      }

      //인증성공
      if (resultCode == '1') {
        await dispatch(
          certifyDateUpdate({
            htmCertifyKey: selectedItem == 0 ? 'kakaoCertify' : 'tossCertify',
          }),
        ).unwrap();

        //인증여부 다시 부르기
        alertMessage(tCommon('alertMessage.smsSuccess'));
        dispatch(getCertifyFlag());
        onCloseHandler(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      {/* <SubTitleSection title={t('linkToData.step1.title')} img={titleImg} /> */}
      <div>
        <Typography className="body2Medium" style={{ textAlign: 'center' }}>
          {item.title} {t('linkToData.step3.title')}
          <br />
          {t('linkToData.step3.description')}
          <br />
          {item.title} {t('linkToData.step3.description2')}
        </Typography>

        <div
          style={{
            padding: '40px 16px 0px 16px',
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            alignItems: 'center',
          }}>
          <img src={item.img} style={{ width: '70px' }} />
          <Typography className="captionMedium">{t('linkToData.step3.description3')}</Typography>
        </div>
      </div>
      <div
        style={{
          position: 'fixed',
          bottom: 0,
          width: '100%',
          left: 0,
          padding: '20px 16px 30px',
          display: 'flex',
          gap: '40px',
          flexDirection: 'column',
        }}>
        <div style={{ padding: '16px', borderRadius: '8px', background: '#f5f5f5' }}>
          <Typography className="captionMedium" style={{ whiteSpace: 'pre-wrap' }}>
            {/* {t('linkToData.step3.description4')}
            <br /> */}
            {item.description}
          </Typography>
        </div>
        <div>
          <Button value={t('linkToData.step3.button')} fullWidth onClick={certCheck} />
        </div>
      </div>
    </div>
  );
};

export default Step3;
